'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = showingUser;

var _actionTypes = require('../../actions/action-types');

function showingUser() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _actionTypes.HIDE_MINI_PROFILE:
      return Object.assign({}, state, { feedUserId: null });
    case _actionTypes.SHOW_MINI_PROFILE:
      var _action$payload = action.payload,
          feedUserType = _action$payload.feedUserType,
          feedUserRelatedId = _action$payload.feedUserRelatedId;

      return Object.assign({}, state, {
        feedUserId: {
          relatedId: feedUserRelatedId,
          type: feedUserType
        }
      });
    default:
      return state;
  }
}